module.exports = __webpack_public_path__ + "static/img/Tom_Rockliff_mobile.217c7ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Rockliff_mobile.jpg
// module id = lOpi
// module chunks = 0